const initialState = {
  requesting: false,
  puestosCalado: [],
  puestoCalado: null,
  nombrePuestoCalado: null,
  calleA: null,
  calleB: null
}

function selectPuestoCalado (state, action) {
  state.puestoCalado = action.puestoCalado
  state.nombrePuestoCalado = action.nombrePuestoCalado
  state.calleA = action.calleA
  state.calleB = action.calleB
};

function requestPuestosCalado (state, action) {
  state.requesting = true
  state.puestosCalado = []
};

function receivePuestosCalado (state, action) {
  state.requesting = false
  state.puestosCalado = action.puestosCalado
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CAMBIAR_PUESTO_CALADO':
      selectPuestoCalado(state, action)
      return state
    case 'RECEIVE_PUESTOS_CALADO':
      receivePuestosCalado(state, action)
      return state
    case 'REQUEST_PUESTOS_CALADO':
      requestPuestosCalado(state, action)
      return state
    default:
      return state
  }
}
